interface ProgressBarProps {
  value: number; // 0–100
  color?: string; // optional custom color
}

export default function ProgressBar({ value, color }: ProgressBarProps) {
  return (
    <div className="h-4 w-full overflow-hidden rounded-[99rem] bg-[#e0e0e0]">
      <div
        className="h-full rounded-[99rem] transition-[width] duration-300 ease-in-out"
        style={{ background: color || "var(--primary)", width: `${value}%` }}
      />
    </div>
  );
}
